import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {toast } from "react-toastify";


function EditTimesheet({caseId: propCaseId, entry, onClose, onUpdated }) {
  const [formData, setFormData] = useState({
    caseId: propCaseId || '',
    clientName: '',
    task: '',
    duration: '',
    notes: '',
    billable: false,
  });
  const [cases, setCases] = useState([]);
  useEffect(() => {
    if (entry) {
      setFormData({
        caseTitle: entry.caseTitle,
        clientName: entry.clientName,
        task: entry.task,
        duration: entry.duration,
        notes: entry.notes,
        billable: entry.billable,
      });
    }
  }, [entry]);

   useEffect(() => {
    if (!propCaseId) {
      const fetchCases = async () => {
        try {
          const token = localStorage.getItem("token");

          const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/projects`,{
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          });
        
          setCases(res.data);
        } catch (error) {
          console.error('Error fetching cases:', error);
        }
      };
      fetchCases();
    }
  }, [propCaseId]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    
    if (!formData.caseId) {
      alert('Please select a case.');
      return;
    }

    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets/${entry._id}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      toast.success("Timesheet updated successfully.!");
      if (onUpdated) {
        onUpdated(); // Refresh list and close modal
      } else {
        onClose();
      }
    } catch (error) {
      console.error('Error updating timesheet:', error);
      toast.error("Failed to update timesheet");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Case dropdown only if not inside CaseDetails */}
        {!propCaseId && (
          <div>
            <label className="block mb-1 font-medium">Project</label>
            <select
              name="caseId"
              value={formData.caseId}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">Select Project</option>
              {cases.map((caseItem) => (
                <option key={caseItem._id} value={caseItem._id}>
                  {caseItem.caseTitle}
                </option>
              ))}
            </select>
          </div>
        )}
       
     
      </div>
      <div>
        <label className="block text-gray-700">Client Name</label>
        <input
          type="text"
          name="clientName"
          value={formData.clientName}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded"
          required
        />
      </div>
      <div>
        <label className="block text-gray-700">Task</label>
        <input
          type="text"
          name="task"
          value={formData.task}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded"
          required
        />
      </div>
      <div>
        <label className="block text-gray-700">Duration</label>
        <input
          type="text"
          name="duration"
          value={formData.duration}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded"
          required
        />
      </div>
      <div>
        <label className="block text-gray-700">Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded"
        />
      </div>
      <div className="flex items-center">
        <input
          type="checkbox"
          name="billable"
          checked={formData.billable}
          onChange={handleChange}
          className="mr-2"
        />
        <label>Billable</label>
      </div>
      <div className="flex justify-between pt-4">
        <button type="button" onClick={onClose} className="bg-gray-500 text-white p-2 rounded">
          Cancel
        </button>
        <button type="submit" className="bg-blue-600 text-white p-2 rounded">
          Update Timesheet
        </button>
      </div>
    </form>
  );
}

export default EditTimesheet;
